"use strict";

exports.__esModule = true;
exports.itemTypePassportRoute = itemTypePassportRoute;
exports.ItemTypePassportPath = exports.ItemTypePassportTitle = exports.ItemTypePassportName = void 0;

var _createRoute = require("../../../../../../react-static/route/createRoute");

var _ItemType = require("../ItemType");

var _slugify = require("../../../../../../html/slugify");

var ItemTypePassportName = "Passport";
exports.ItemTypePassportName = ItemTypePassportName;
var ItemTypePassportTitle = (0, _ItemType.ItemTypeTitle)(ItemTypePassportName);
exports.ItemTypePassportTitle = ItemTypePassportTitle;
var ItemTypePassportPath = (0, _ItemType.ItemTypeItemPath)((0, _slugify.slugify)(ItemTypePassportName));
exports.ItemTypePassportPath = ItemTypePassportPath;

function itemTypePassportRoute(rootPath) {
  var route = (0, _createRoute.createRoute)(rootPath, ItemTypePassportPath);

  route.getData = function () {
    return {
      path: ItemTypePassportPath
    };
  };

  return route;
}